import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

function Privacidad() {
  const navigate = useNavigate();

  return (
    <div className="contenedor" style={{ maxWidth: '700px', margin: '0 auto', padding: '2rem 1.5rem 4rem' }}>
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>

        <button
          onClick={() => navigate('/')}
          style={{ background:'transparent', border:'none', color:'var(--color-oro)',
            cursor:'pointer', fontSize:'0.85rem', marginBottom:'1.5rem', padding:0 }}
        >
          ← Volver al inicio
        </button>

        <h1 style={{ fontFamily:'var(--fuente-titulo)', color:'var(--color-oro)',
          fontSize:'1.6rem', marginBottom:'0.3rem' }}>
          Política de Privacidad
        </h1>
        <p style={{ color:'var(--color-texto-suave)', fontSize:'0.78rem', marginBottom:'2rem' }}>
          Última actualización: 3 de marzo de 2026
        </p>

        {[
          {
            titulo: '1. Información que recopilamos',
            texto: `Cuando usas Tu Mano Dice recopilamos:
• Imagen de tu mano (solo para análisis, no se almacena permanentemente)
• Nombre que proporcionas voluntariamente
• Intención de lectura que seleccionas
• Información de pago procesada por PayPal (no almacenamos datos de tarjetas)
• Datos de uso anónimos a través de cookies de Google AdSense y Google Analytics`
          },
          {
            titulo: '2. Cómo usamos tu información',
            texto: `Usamos la información únicamente para:
• Generar tu lectura de quiromancia personalizada
• Procesar pagos de forma segura a través de PayPal
• Mejorar la experiencia del servicio
• Mostrar publicidad relevante a través de Google AdSense`
          },
          {
            titulo: '3. Google AdSense y cookies',
            texto: `Este sitio usa Google AdSense para mostrar anuncios. Google y sus socios usan cookies para mostrar anuncios basados en tus visitas anteriores. Puedes desactivar la publicidad personalizada en: https://www.google.com/settings/ads

Las cookies de AdSense nos ayudan a financiar el servicio gratuito.`
          },
          {
            titulo: '4. Pagos con PayPal',
            texto: `Los pagos se procesan de forma segura a través de PayPal. No almacenamos datos de tarjetas de crédito ni información financiera. Consulta la política de privacidad de PayPal en paypal.com para más detalles.`
          },
          {
            titulo: '5. Almacenamiento de imágenes',
            texto: `Las imágenes de tu mano se suben temporalmente a Amazon S3 para su análisis. Se eliminan automáticamente. No las compartimos con terceros ni las usamos para ningún otro propósito.`
          },
          {
            titulo: '6. Tus derechos',
            texto: `Tienes derecho a:
• Solicitar la eliminación de tus datos
• Conocer qué información tenemos sobre ti
• Optar por no recibir publicidad personalizada

Para ejercer estos derechos contáctanos en: privacidad@tumanodice.com`
          },
          {
            titulo: '7. Menores de edad',
            texto: `Este servicio no está dirigido a menores de 13 años. No recopilamos intencionalmente información de menores.`
          },
          {
            titulo: '8. Cambios a esta política',
            texto: `Podemos actualizar esta política ocasionalmente. Te notificaremos publicando la nueva versión en esta página con la fecha de actualización.`
          },
          {
            titulo: '9. Contacto',
            texto: `Si tienes preguntas sobre esta política de privacidad, contáctanos:\n\nSitio web: tumanodice.com\nCorreo: privacidad@tumanodice.com`
          },
        ].map((s, i) => (
          <div key={i} style={{ marginBottom: '1.8rem' }}>
            <h2 style={{ color: 'var(--color-oro)', fontSize: '1rem',
              fontFamily: 'var(--fuente-titulo)', marginBottom: '0.6rem' }}>
              {s.titulo}
            </h2>
            <p style={{ color: 'var(--color-texto-suave)', fontSize: '0.88rem',
              lineHeight: 1.7, whiteSpace: 'pre-line' }}>
              {s.texto}
            </p>
          </div>
        ))}

      </motion.div>
    </div>
  );
}

export default Privacidad;
